var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnCategoryWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.928,
    height: 18.744,
    viewBox: "0 0 20.928 18.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-category-warning",
    transform: "translate(0.537 0.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-7018.208-1637.507h-12.259a3.611,3.611,0,0,1-3.183-1.877,3.7,3.7,0,0,1,.046-3.727l6.129-10.333a3.626,3.626,0,0,1,3.089-1.8l0,0c.06,0,.12,0,.181,0a3.679,3.679,0,0,1,3.179,1.8l6.21,10.333a3.647,3.647,0,0,1,.048,3.727,3.671,3.671,0,0,1-3.227,1.877Z",
    transform: "translate(7034.131 1655.239)",
    fill: "#f15a24",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730",
    transform: "translate(9.234 5.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M-468.942,1523.04c-.659,0-1.194-.394-1.194-.88v-5.279c0-.486.535-.88,1.194-.88s1.194.394,1.194.88v5.279C-467.748,1522.646-468.283,1523.04-468.942,1523.04Z",
    transform: "translate(469.828 -1517.071)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M-467.427,1563.693a1.171,1.171,0,0,1-1.194,1.147,1.171,1.171,0,0,1-1.194-1.147,1.171,1.171,0,0,1,1.194-1.147A1.171,1.171,0,0,1-467.427,1563.693Z",
    transform: "translate(469.507 -1555.97)",
    fill: "#f4f5f7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCategoryWarning);
export default __webpack_public_path__ + "static/media/icn-category-warning.d7696d9b38756a48b9c1b97e7cc331c3.svg";
export { ForwardRef as ReactComponent };